import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	PetitionDecisionMakersAndLegislativeBodiesQuery,
	PetitionDecisionMakersAndLegislativeBodiesQueryVariables,
} from './api.graphql';
import { PetitionDecisionMakersAndLegislativeBodies } from './api.graphql';

export type DecisionMakersAndLegislativeBodies = NonNullable<
	PetitionDecisionMakersAndLegislativeBodiesQuery['petition']
>['dmsWithLegislativeBodiesConnection']['nodes'];

export async function getAllDmsAndLBs(slugOrId: string, { gql: { fetch } }: UtilityContext) {
	const { data } = await fetch<
		PetitionDecisionMakersAndLegislativeBodiesQuery,
		PetitionDecisionMakersAndLegislativeBodiesQueryVariables
	>({
		query: PetitionDecisionMakersAndLegislativeBodies,
		variables: {
			slugOrId,
		},
		rejectOnError: true,
	});

	if (!data.petition?.dmsWithLegislativeBodiesConnection)
		throw new Error('Unable to fetch decision makers and legislative bodies');

	return data.petition.dmsWithLegislativeBodiesConnection;
}
